// test611
(611 && 0);
